import d from 'dayjs';
import isSameOrAfter from 'dayjs/plugin/isSameOrAfter';
import isSameOrBefore from 'dayjs/plugin/isSameOrBefore';
import timezone from 'dayjs/plugin/timezone';
import utc from 'dayjs/plugin/utc';
d.extend(utc);
d.extend(timezone);
d.extend(isSameOrAfter);
d.extend(isSameOrBefore);
/**
 * Best guess at the user's current time zone (as detected by their browser)
 */
export var userTimeZone = d.tz.guess();
/**
 * Singleton, pre-configured instance of DayJS to use for all DatePicker operations
 */
export var dayjs = d;
